const buildUrl = _ref => {
  let {
    url,
    params
  } = _ref;
  const baseUrl = window.location.origin;
  const urlWithParams = new URL(url, baseUrl);
  if (params) {
    const filteredParams = Object.entries(params).filter(_ref2 => {
      let [_, value] = _ref2;
      return !!value;
    });
    filteredParams.forEach(_ref3 => {
      let [key, value] = _ref3;
      urlWithParams.searchParams.set(key, (value == null ? void 0 : value.toString()) ?? '');
    });
  }
  return urlWithParams.toString();
};
export const UrlUtils = {
  buildUrl
};
//# sourceMappingURL=url-utils.js.map